"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EDITORIAL_PAGE = void 0;
const EDITORIAL_PAGE = exports.EDITORIAL_PAGE = 'editorial-page';
